/** Office supplies text and an image for the same copied selection. Prefer text. */
export function shouldPasteAsText(clipboard: DataTransfer | null): boolean {
  return Boolean(clipboard?.getData('text/plain')?.trim());
}
